<template>
  <v-layout wrap justify-center>
    <ServerError v-if="ServerError" />
    <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="blue"
      spinner="mini-spinner"
    />
    <v-snackbar
      :timeout="3000"
      :value="true"
      right
      color="red"
      v-model="showsnackbar"
    >
      <span style="font-size: 20px"> {{ msg }}</span>
    </v-snackbar>
    <v-flex xs12 lg11 pt-6>
      <v-layout wrap justify-center>
        <v-flex xs12>
          <v-card
            class="mx-auto elevation-1 pa-6"
            max-width="1088px"
            align="center"
            outlined
          >
            <v-layout wrap justify-space-between>
              <v-flex
                xs12
                sm6
                pb-2
                pb-md-0
                class="text-left nsbold"
                style="font-weight: 700; font-size: 20px"
                >Send Notification
              </v-flex>
            </v-layout>

            <v-layout wrap>
              <v-flex xs12 align-self-center>
                <v-form ref="form" v-model="valid" lazy-validation>
                  <v-layout wrap justify-start pa-4>
                    <v-flex xs12 sm6 align-self-center pa-2>
                      <v-text-field
                        dense
                        hide-details
                        outlined
                        required
                        label="Title"
                        v-model="ntitle"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 align-self-center pa-2>
                      <v-text-field
                        dense
                        hide-details
                        outlined
                        required
                        label="Description"
                        v-model="nbody"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 align-self-center pa-2>
                      <v-select
                        dense
                        hide-details
                        outlined
                        required
                        item-text="name"
                        item-value="_id"
                        :items="busList"
                        label="Choose Bus"
                        v-model="busId"
                      ></v-select>
                    </v-flex>
                    <v-flex xs12 sm6 align-self-center pa-2 v-if="busId">
                      <v-select
                        dense
                        hide-details
                        outlined
                        required
                        :item-text="
                          (item) => item.name + ' - ' + item.routeId.name
                        "
                        multiple
                        item-value="_id"
                        :items="tripList"
                        label="Choose Trip"
                        v-model="tripId"
                      ></v-select>
                    </v-flex>
                    <v-flex xs12 align-self-center pa-2 v-if="tripArr">
                      <v-card tile outlined v-if="tripArr.length > 0">
                        <v-layout
                          wrap
                          justify-start
                          v-if="tripArr.length > 0"
                          pa-3
                        >
                          <v-flex xs12 align-self-center text-left>
                            <span class="nsbold">Selected Trips</span>
                          </v-flex>
                          <v-flex
                            align-self-center
                            pa-2
                            v-for="(main, m) in tripArr"
                            :key="m"
                          >
                            <v-btn
                              dark
                              class="rounded-xl text-none"
                              color="white"
                              text
                              x-small
                            >
                              <v-card
                                flat
                                outlined
                                class="rounded-xl"
                                color="#766BC0"
                                width="100%"
                              >
                                <v-layout wrap justify-space-between>
                                  <v-flex align-self-center text-left px-4>
                                    <span class="nsbold">
                                      {{ main.name }}
                                    </span>
                                  </v-flex>
                                  <v-flex align-self-center text-right>
                                    <v-btn fab x-small text color="transparent">
                                      <v-icon
                                        small
                                        title="Remove"
                                        @click.prevent="tripArr.splice(m, 1)"
                                        dark
                                        color="white"
                                        >mdi-close</v-icon
                                      >
                                    </v-btn>
                                  </v-flex>
                                </v-layout>
                              </v-card>
                            </v-btn>
                          </v-flex>
                        </v-layout>
                      </v-card>
                    </v-flex>

                    <v-flex xs12>
                      <v-spacer></v-spacer>
                    </v-flex>
                    <v-flex xs12 sm4 md3 pa-2 align-self-center text-center>
                      <v-btn
                        :disabled="!valid"
                        color="#766BC0"
                        class="body-2 font-weight-bold"
                        block
                        dark
                        @click="validateInput()"
                        >Submit</v-btn
                      >
                    </v-flex>
                  </v-layout>
                </v-form>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>

      <v-dialog width="450px" v-model="dialoge">
        <v-card>
          <v-toolbar dark color="#766BC0" dense flat class="body-2">
            <v-toolbar-title> Confirm Delete </v-toolbar-title>
          </v-toolbar>
          <v-card-text class="pa-4 black--text"
            >Are you sure you want to delete this record?
          </v-card-text>
          <v-card-actions class="pt-3">
            <v-spacer></v-spacer>
            <v-btn
              color="grey"
              text
              class="body-2 font-weight-bold"
              @click="dialoge = false"
              >Cancel</v-btn
            >
            <v-btn
              color="#766BC0"
              class="body-2 font-weight-bold"
              outlined
              @click="deleteTrip()"
              >OK</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      page: 1,
      Pagelength: 0,
      dialoge: false,
      editdialogue: false,
      showsnackbar: false,
      msg: null,
      appLoading: false,
      ServerError: false,
      valid: true,
      sectionData: {},
      curItem: {},
      tripList: null,
      mapData: {},
      show2: true,
      searchInput: "",
      rules: {
        required: (value) => !!value || "Required.",
        counter: (value) => value.length <= 20 || "Max 20 characters",
        phoneRules: [
          (v) => !!v || "phone is required",
          (v) =>
            (v && v.length <= 10) || "number must be less than 11 characters",
          (v) =>
            (v && v.length >= 10) ||
            "number must be greater than 10 characters",
          (v) => /^\d{10}$/.test(v) || "phone number must be a number",
        ],
        email: (value) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        },
      },
      doManual: false,
      addDialog: false,
      busList: [],
      students: [],
      placeList: [],
      division: null,
      cls: null,
      divisionList: null,
      classList: null,
      keyword: "",
      tripId: null,
      busId: null,
      tripArr: [],
      tripIdArr: [],
      ntitle: null,
      nbody: null,
    };
  },
  beforeMount() {
    this.getBus();
  },
  watch: {
    busId() {
      this.getTrips();
      this.tripId = [];
    },
    tripId() {
      if (this.tripId.length > 0)
        for (let i = 0; i < this.tripId.length; i++) {
          if (!this.tripIdArr.includes(this.tripId[i])) {
            this.tripIdArr.push(this.tripId[i]);
          }
        }
      if (this.tripIdArr.length > 0) {
        this.tripList = this.tripList.map((x) => {
          if (this.tripIdArr.includes(x._id)) {
            var a = this.tripArr.filter((y) => y._id == x._id);

            if (a.length < 1) this.tripArr.push(x);
          }
          return x;
        });
      } 
    },
  },
  methods: {
    getBus() {
      this.appLoading = true;
      axios({
        method: "get",
        url: "/bus/admin/list",
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.busList = response.data.data;
          } else {
            this.snackbar = true;
            this.msg = response.data.msg;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
    getTrips() {
      this.appLoading = true;
      axios({
        method: "post",
        url: "/bus/trip/list",
        headers: {
          token: localStorage.getItem("token"),
        },
        data: {
          busid: this.busId,
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.tripList = response.data.data;
          } else {
            this.snackbar = true;
            this.msg = response.data.msg;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },

    validateInput() {
      if (this.tripArr.length <= 0) {
        this.msg = "Please select any trip(s)";
        this.showsnackbar = true;
        return;
      } else if (!this.ntitle || !this.nbody) {
        this.msg = "All fields are required*";
        this.showsnackbar = true;
        return;
      } else this.sendNotification();
    },
    //add button
    sendNotification() {
      {
        var data = {};
        data["title"] = this.ntitle;
        data["body"] = this.nbody;
        var arr = this.tripArr.map((x) => x._id);
        data["tripIds"] = arr;
        this.appLoading = true;
        axios({
          url: "/bus/admin/notify/parents",
          method: "POST",
          headers: {
            token: localStorage.getItem("token"),
          },
          data: data,
        })
          .then((response) => {
            this.appLoading = false;

            if (response.data.status) {
              this.addDialog = false;
              this.msg = response.data.msg;
              this.showsnackbar = true;
              this.ntitle = null;
              this.nbody = null;
              this.tripArr = [];
              this.tripIdArr = [];
              this.tripId = null;
              this.busId = null;

              this.$refs.form.reset();
              this.$refs.form.resetValidation();
            } else {
              this.msg = response.data.msg;
              this.showsnackbar = true;
            }
          })
          .catch((err) => {
            this.appLoading = false;
            this.ServerError = true;
            console.log(err);
          });
      }
    },
  },
};
</script>
<style scoped>
#map44 {
  height: 100%;
}
</style>
